import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

/**
 * @param {
 *   deviceId: string,
 *   userId: string,
 *   tenantId: string,
 *   siteId: string,
 *   size:number, [Record per page]
 *   pageNo:number,  [Current page number]
 *   filters: object,
 *   sort: array
 * } queryParam
 * @returns Promise
 */

export const getDeviceDiagonosticReportdata = (queryParam) => {
  /**End Point:- getDeviceDiagonosticData**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDeviceDiagnosticData,
    queryParam
  );
};

/**
 * @param {
 *   deviceId: string,
 *   userId: string,
 *   tenantId: string,
 *   siteId: string,
 *   size:number, [Record per page]
 *   pageNo:number,  [Current page number]
 *   filters: object,
 *   sort: array
 * } queryParam
 * @returns Promise
 */

export const getDeviceParamReportdata = (queryParam) => {
  /**End Point:- getDeviceParamData**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDeviceParameterData,
    queryParam
  );
};

/**
 * @param {
  *  "userId": "a1743cce-9ec7-4a45-baf2-2b0c901fb2a1",
  * "tenantId": "8915a57f-f3d1-4a6d-adb3-85ea98d1747e",
  * "siteId": "ce28e55a-d2cf-4de4-9309-aa159c553d3c",
  * "reportType": "Device Diagnostics",
  * "filters": {
  *   // The same fields and values that is used in the report list APIs, depending on the report type
  },
  * "sort": [
      // The same fields and values that is used in the report list APIs, depending on the report type
  ]
  * } queryParam
* @returns Promise
*/

export const generateCSVReport = (queryParam) => {
  /**End Point:- generateCSVReport**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.generateDeviceTelemetryCsvReport,
    queryParam
  );
};

export const getDeviceDataForGraph = (queryParam) => {
  /**End Point:- getDeviceDataForGraph**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDeviceTelemetryForGraph,
    queryParam
  );
};

export const getReportsForAUser = (queryParam) => {
  /**End Point:- getReportsForAUser**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getReports,
    queryParam
  );
};

export const generateGraphReport = (queryParam) => {
  /**End Point:- generateGraphReport**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.generateGraphReport,
    queryParam
  );
};

export const cancelReportGeneration = (queryParam) => {
  /**End Point:- cancelReportGeneration**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.cancelReportGeneration,
    queryParam
  );
};


/**
 * @param {
*   requestedUserId: string,
*   tenantId: string,
*   size:number, [Record per page]
*   pageNo:number,  [Current page number]
*   filters: object,
*   sort: array
* } queryParam
* @returns Promise
*/

export const auditTrailReportdata = (queryParam) => {
  /**End Point:- getAuditTrail**/
 return axiosInstance.post(
   backendConfig.API_URL + backendConfig.API_END_POINTS.getAuditTrail,
   queryParam
 );
};


/**
 * @param {
*   requestedUserId: string,
*   tenantId: string,
*   sort: array,
*   userTimezone: string
* } queryParam
* @returns Promise
*/

export const generateAuditTrailCSVReport = (queryParam) => {
  /**End Point:- generateAuditTrailCSVReport**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.generateAuditTrailCsvReport,
    queryParam
  );
};
 
/**
 * @param {
*   userId: string,
*   tenantId: string,
*   siteId: string,
*   isDateWiseReport: boolean,
*   filters: object,
* } queryParam
* @returns Promise
*/

export const getSummaryDetailsData = (queryParam) => {
  /**End Point:- getDeviceSummaryDetails**/
 return axiosInstance.post(
   backendConfig.API_URL + backendConfig.API_END_POINTS.getDeviceSummaryData,
   queryParam
 );
};

/**
 * @param {
*   userId: string,
*   tenantId: string,
*   siteId: string,
*   deviceId: string,
*   reportType: string,
*   intervalType: array,
*   isDateWiseReport: boolean,
*   userTimezone: string
*   filters: object,
*   sort: array,
* } queryParam
* @returns Promise
*/

export const generateSummaryCSVReport = (queryParam) => {
  /**End Point:- generateDeviceSummaryReport**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.generateDeviceSummaryCsvReport,
    queryParam
  );
};

/**
 * @param {
*   requestedUserId: string,
*   filters: object,
*   sort: array,
*   size: number,
*   pageNo: number,
* } queryParam
* @returns Promise
*/

export const getDeviceUpdateListData = (queryParam) => {
  /**End Point:- getDeviceUpdateListForReport**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDeviceUpdateList,
    queryParam
  );
};


/**
 * @param {
*   requestedUserId: string,
*   userTimezone: string
*   filters: object,
*   sort: array,
* } queryParam
* @returns Promise
*/

export const generateDeviceUpdateCsvReport = (queryParam) => {
  /**End Point:- generateDeviceUpdateListCSVReport**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.generateDeviceUpdateCsvReport,
    queryParam
  );
};
